export default __webpack_public_path__ + "static/media/book6.9daec496.jpeg";